__webpack_require__.p = "/issues/40/selections-from-the-revue-des-colonies-july-1834-and-july-1835/";